import { CAMPAIGN_STEP_NAMES_MAPPER } from '../../constants';
import { useCampaignContext, useEditorContext, useTemplateContext } from '../../context';
import { getHasStoAndSendTimeExperiment } from '../../utils';
import { getScheduledCampaignTypeHasNoLists } from '../utils';

export const MISSING_AUDIENCE_MESSAGE = 'Missing Audience';
export const MISSING_TEMPLATE_MESSAGE = `Missing template`;
export const CONTENT_ERRORS_MESSAGE = `Content errors`;
export const CANNOT_USE_BOTH_STO_AND_SEND_TIME_EXP_MESSAGE = `Send Time Optimization and send time experiments can't be used together. To send this campaign, first turn off Send Time Optimization or remove the send time experiment.`;
export const NBA_LOCALE_ERROR_MESSAGE =
  'Next Best Action cannot be used with non-English locales. Please remove any before continuing.';

export const usePopoverDetails = () => {
  const { currentEditableStep } = useEditorContext();
  const { campaign } = useCampaignContext();
  const { templateState } = useTemplateContext();
  const { isDefaultTemplate, noTemplate, errorCount, hasInvalidNbaLocales } = templateState;
  const hasSTOAndSendTimeExperiment = getHasStoAndSendTimeExperiment(campaign);
  const scheduledCampaignTypeHasNoLists = getScheduledCampaignTypeHasNoLists(campaign);

  const items = [
    ...(scheduledCampaignTypeHasNoLists ? [MISSING_AUDIENCE_MESSAGE] : []),
    ...(!!errorCount && !isDefaultTemplate ? [CONTENT_ERRORS_MESSAGE] : []),
    ...(isDefaultTemplate || noTemplate ? [MISSING_TEMPLATE_MESSAGE] : []),
    ...(hasSTOAndSendTimeExperiment ? [CANNOT_USE_BOTH_STO_AND_SEND_TIME_EXP_MESSAGE] : []),
    ...(currentEditableStep
      ? [`Currently editing ${CAMPAIGN_STEP_NAMES_MAPPER[currentEditableStep]}`]
      : []),
    ...(hasInvalidNbaLocales ? [NBA_LOCALE_ERROR_MESSAGE] : []),
  ];

  return items;
};
